import { render, staticRenderFns } from "./custom-object-about.vue?vue&type=template&id=1c0abf6b&scoped=true&"
import script from "./custom-object-about.js?vue&type=script&lang=js&"
export * from "./custom-object-about.js?vue&type=script&lang=js&"
import style0 from "./custom-object-about.scss?vue&type=style&index=0&id=1c0abf6b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0abf6b",
  null
  
)

component.options.__file = "custom-object-about.vue"
export default component.exports